import {Loc} from 'landing.loc';

export const SimpleLinePro1 = {
	id: 'simple_line_icons_pro_1',
	name: 'Simple Line Icon Pro 1',
	active: true,
	categories: [
		{
			id: 'simple_line_0',
			name: Loc.getMessage('LANDING_ICONS_SECTION_HOTEL_AND_RESTAURANT'),
			items: [
				'u-line-icon-pro icon-hotel-restaurant-001',
				'u-line-icon-pro icon-hotel-restaurant-002',
				'u-line-icon-pro icon-hotel-restaurant-003',
				'u-line-icon-pro icon-hotel-restaurant-004',
				'u-line-icon-pro icon-hotel-restaurant-005',
				'u-line-icon-pro icon-hotel-restaurant-006',
				'u-line-icon-pro icon-hotel-restaurant-007',
				'u-line-icon-pro icon-hotel-restaurant-008',
				'u-line-icon-pro icon-hotel-restaurant-009',
				'u-line-icon-pro icon-hotel-restaurant-010',
				'u-line-icon-pro icon-hotel-restaurant-011',
				'u-line-icon-pro icon-hotel-restaurant-065',
				'u-line-icon-pro icon-hotel-restaurant-012',
				'u-line-icon-pro icon-hotel-restaurant-013',
				'u-line-icon-pro icon-hotel-restaurant-026',
				'u-line-icon-pro icon-hotel-restaurant-025',
				'u-line-icon-pro icon-hotel-restaurant-024',
				'u-line-icon-pro icon-hotel-restaurant-023',
				'u-line-icon-pro icon-hotel-restaurant-022',
				'u-line-icon-pro icon-hotel-restaurant-021',
				'u-line-icon-pro icon-hotel-restaurant-020',
				'u-line-icon-pro icon-hotel-restaurant-019',
				'u-line-icon-pro icon-hotel-restaurant-018',
				'u-line-icon-pro icon-hotel-restaurant-017',
				'u-line-icon-pro icon-hotel-restaurant-016',
				'u-line-icon-pro icon-hotel-restaurant-015',
				'u-line-icon-pro icon-hotel-restaurant-014',
				'u-line-icon-pro icon-hotel-restaurant-027',
				'u-line-icon-pro icon-hotel-restaurant-028',
				'u-line-icon-pro icon-hotel-restaurant-029',
				'u-line-icon-pro icon-hotel-restaurant-030',
				'u-line-icon-pro icon-hotel-restaurant-031',
				'u-line-icon-pro icon-hotel-restaurant-032',
				'u-line-icon-pro icon-hotel-restaurant-033',
				'u-line-icon-pro icon-hotel-restaurant-034',
				'u-line-icon-pro icon-hotel-restaurant-035',
				'u-line-icon-pro icon-hotel-restaurant-036',
				'u-line-icon-pro icon-hotel-restaurant-038',
				'u-line-icon-pro icon-hotel-restaurant-039',
				'u-line-icon-pro icon-hotel-restaurant-037',
				'u-line-icon-pro icon-hotel-restaurant-052',
				'u-line-icon-pro icon-hotel-restaurant-051',
				'u-line-icon-pro icon-hotel-restaurant-050',
				'u-line-icon-pro icon-hotel-restaurant-049',
				'u-line-icon-pro icon-hotel-restaurant-048',
				'u-line-icon-pro icon-hotel-restaurant-047',
				'u-line-icon-pro icon-hotel-restaurant-046',
				'u-line-icon-pro icon-hotel-restaurant-045',
				'u-line-icon-pro icon-hotel-restaurant-044',
				'u-line-icon-pro icon-hotel-restaurant-042',
				'u-line-icon-pro icon-hotel-restaurant-041',
				'u-line-icon-pro icon-hotel-restaurant-040',
				'u-line-icon-pro icon-hotel-restaurant-043',
				'u-line-icon-pro icon-hotel-restaurant-053',
				'u-line-icon-pro icon-hotel-restaurant-054',
				'u-line-icon-pro icon-hotel-restaurant-055',
				'u-line-icon-pro icon-hotel-restaurant-056',
				'u-line-icon-pro icon-hotel-restaurant-057',
				'u-line-icon-pro icon-hotel-restaurant-058',
				'u-line-icon-pro icon-hotel-restaurant-059',
				'u-line-icon-pro icon-hotel-restaurant-060',
				'u-line-icon-pro icon-hotel-restaurant-061',
				'u-line-icon-pro icon-hotel-restaurant-062',
				'u-line-icon-pro icon-hotel-restaurant-063',
				'u-line-icon-pro icon-hotel-restaurant-064',
				'u-line-icon-pro icon-hotel-restaurant-066',
				'u-line-icon-pro icon-hotel-restaurant-079',
				'u-line-icon-pro icon-hotel-restaurant-092',
				'u-line-icon-pro icon-hotel-restaurant-105',
				'u-line-icon-pro icon-hotel-restaurant-118',
				'u-line-icon-pro icon-hotel-restaurant-131',
				'u-line-icon-pro icon-hotel-restaurant-144',
				'u-line-icon-pro icon-hotel-restaurant-157',
				'u-line-icon-pro icon-hotel-restaurant-067',
				'u-line-icon-pro icon-hotel-restaurant-080',
				'u-line-icon-pro icon-hotel-restaurant-068',
				'u-line-icon-pro icon-hotel-restaurant-081',
				'u-line-icon-pro icon-hotel-restaurant-093',
				'u-line-icon-pro icon-hotel-restaurant-094',
				'u-line-icon-pro icon-hotel-restaurant-095',
				'u-line-icon-pro icon-hotel-restaurant-096',
				'u-line-icon-pro icon-hotel-restaurant-097',
				'u-line-icon-pro icon-hotel-restaurant-098',
				'u-line-icon-pro icon-hotel-restaurant-099',
				'u-line-icon-pro icon-hotel-restaurant-100',
				'u-line-icon-pro icon-hotel-restaurant-101',
				'u-line-icon-pro icon-hotel-restaurant-102',
				'u-line-icon-pro icon-hotel-restaurant-103',
				'u-line-icon-pro icon-hotel-restaurant-104',
				'u-line-icon-pro icon-hotel-restaurant-091',
				'u-line-icon-pro icon-hotel-restaurant-090',
				'u-line-icon-pro icon-hotel-restaurant-089',
				'u-line-icon-pro icon-hotel-restaurant-088',
				'u-line-icon-pro icon-hotel-restaurant-087',
				'u-line-icon-pro icon-hotel-restaurant-086',
				'u-line-icon-pro icon-hotel-restaurant-085',
				'u-line-icon-pro icon-hotel-restaurant-084',
				'u-line-icon-pro icon-hotel-restaurant-083',
				'u-line-icon-pro icon-hotel-restaurant-082',
				'u-line-icon-pro icon-hotel-restaurant-069',
				'u-line-icon-pro icon-hotel-restaurant-070',
				'u-line-icon-pro icon-hotel-restaurant-071',
				'u-line-icon-pro icon-hotel-restaurant-072',
				'u-line-icon-pro icon-hotel-restaurant-073',
				'u-line-icon-pro icon-hotel-restaurant-074',
				'u-line-icon-pro icon-hotel-restaurant-075',
				'u-line-icon-pro icon-hotel-restaurant-076',
				'u-line-icon-pro icon-hotel-restaurant-077',
				'u-line-icon-pro icon-hotel-restaurant-078',
				'u-line-icon-pro icon-hotel-restaurant-117',
				'u-line-icon-pro icon-hotel-restaurant-116',
				'u-line-icon-pro icon-hotel-restaurant-115',
				'u-line-icon-pro icon-hotel-restaurant-114',
				'u-line-icon-pro icon-hotel-restaurant-113',
				'u-line-icon-pro icon-hotel-restaurant-112',
				'u-line-icon-pro icon-hotel-restaurant-111',
				'u-line-icon-pro icon-hotel-restaurant-110',
				'u-line-icon-pro icon-hotel-restaurant-109',
				'u-line-icon-pro icon-hotel-restaurant-108',
				'u-line-icon-pro icon-hotel-restaurant-107',
				'u-line-icon-pro icon-hotel-restaurant-106',
				'u-line-icon-pro icon-hotel-restaurant-119',
				'u-line-icon-pro icon-hotel-restaurant-120',
				'u-line-icon-pro icon-hotel-restaurant-121',
				'u-line-icon-pro icon-hotel-restaurant-122',
				'u-line-icon-pro icon-hotel-restaurant-123',
				'u-line-icon-pro icon-hotel-restaurant-124',
				'u-line-icon-pro icon-hotel-restaurant-125',
				'u-line-icon-pro icon-hotel-restaurant-126',
				'u-line-icon-pro icon-hotel-restaurant-127',
				'u-line-icon-pro icon-hotel-restaurant-128',
				'u-line-icon-pro icon-hotel-restaurant-129',
				'u-line-icon-pro icon-hotel-restaurant-130',
				'u-line-icon-pro icon-hotel-restaurant-143',
				'u-line-icon-pro icon-hotel-restaurant-142',
				'u-line-icon-pro icon-hotel-restaurant-141',
				'u-line-icon-pro icon-hotel-restaurant-140',
				'u-line-icon-pro icon-hotel-restaurant-139',
				'u-line-icon-pro icon-hotel-restaurant-138',
				'u-line-icon-pro icon-hotel-restaurant-137',
				'u-line-icon-pro icon-hotel-restaurant-136',
				'u-line-icon-pro icon-hotel-restaurant-135',
				'u-line-icon-pro icon-hotel-restaurant-134',
				'u-line-icon-pro icon-hotel-restaurant-133',
				'u-line-icon-pro icon-hotel-restaurant-132',
				'u-line-icon-pro icon-hotel-restaurant-145',
				'u-line-icon-pro icon-hotel-restaurant-146',
				'u-line-icon-pro icon-hotel-restaurant-147',
				'u-line-icon-pro icon-hotel-restaurant-148',
				'u-line-icon-pro icon-hotel-restaurant-149',
				'u-line-icon-pro icon-hotel-restaurant-150',
				'u-line-icon-pro icon-hotel-restaurant-151',
				'u-line-icon-pro icon-hotel-restaurant-152',
				'u-line-icon-pro icon-hotel-restaurant-153',
				'u-line-icon-pro icon-hotel-restaurant-154',
				'u-line-icon-pro icon-hotel-restaurant-155',
				'u-line-icon-pro icon-hotel-restaurant-156',
				'u-line-icon-pro icon-hotel-restaurant-169',
				'u-line-icon-pro icon-hotel-restaurant-168',
				'u-line-icon-pro icon-hotel-restaurant-167',
				'u-line-icon-pro icon-hotel-restaurant-166',
				'u-line-icon-pro icon-hotel-restaurant-165',
				'u-line-icon-pro icon-hotel-restaurant-164',
				'u-line-icon-pro icon-hotel-restaurant-163',
				'u-line-icon-pro icon-hotel-restaurant-162',
				'u-line-icon-pro icon-hotel-restaurant-161',
				'u-line-icon-pro icon-hotel-restaurant-160',
				'u-line-icon-pro icon-hotel-restaurant-159',
				'u-line-icon-pro icon-hotel-restaurant-158',
				'u-line-icon-pro icon-hotel-restaurant-170',
				'u-line-icon-pro icon-hotel-restaurant-171',
				'u-line-icon-pro icon-hotel-restaurant-172',
				'u-line-icon-pro icon-hotel-restaurant-173',
				'u-line-icon-pro icon-hotel-restaurant-174',
				'u-line-icon-pro icon-hotel-restaurant-175',
				'u-line-icon-pro icon-hotel-restaurant-176',
				'u-line-icon-pro icon-hotel-restaurant-177',
				'u-line-icon-pro icon-hotel-restaurant-178',
				'u-line-icon-pro icon-hotel-restaurant-179',
				'u-line-icon-pro icon-hotel-restaurant-180',
				'u-line-icon-pro icon-hotel-restaurant-181',
				'u-line-icon-pro icon-hotel-restaurant-182',
				'u-line-icon-pro icon-hotel-restaurant-195',
				'u-line-icon-pro icon-hotel-restaurant-194',
				'u-line-icon-pro icon-hotel-restaurant-193',
				'u-line-icon-pro icon-hotel-restaurant-192',
				'u-line-icon-pro icon-hotel-restaurant-191',
				'u-line-icon-pro icon-hotel-restaurant-190',
				'u-line-icon-pro icon-hotel-restaurant-189',
				'u-line-icon-pro icon-hotel-restaurant-188',
				'u-line-icon-pro icon-hotel-restaurant-187',
				'u-line-icon-pro icon-hotel-restaurant-186',
				'u-line-icon-pro icon-hotel-restaurant-185',
				'u-line-icon-pro icon-hotel-restaurant-184',
				'u-line-icon-pro icon-hotel-restaurant-183',
				'u-line-icon-pro icon-hotel-restaurant-196',
				'u-line-icon-pro icon-hotel-restaurant-197',
				'u-line-icon-pro icon-hotel-restaurant-198',
				'u-line-icon-pro icon-hotel-restaurant-199',
				'u-line-icon-pro icon-hotel-restaurant-200',
				'u-line-icon-pro icon-hotel-restaurant-201',
				'u-line-icon-pro icon-hotel-restaurant-202',
				'u-line-icon-pro icon-hotel-restaurant-203',
				'u-line-icon-pro icon-hotel-restaurant-204',
				'u-line-icon-pro icon-hotel-restaurant-205',
				'u-line-icon-pro icon-hotel-restaurant-206',
				'u-line-icon-pro icon-hotel-restaurant-207',
				'u-line-icon-pro icon-hotel-restaurant-208',
				'u-line-icon-pro icon-hotel-restaurant-221',
				'u-line-icon-pro icon-hotel-restaurant-220',
				'u-line-icon-pro icon-hotel-restaurant-219',
				'u-line-icon-pro icon-hotel-restaurant-218',
				'u-line-icon-pro icon-hotel-restaurant-217',
				'u-line-icon-pro icon-hotel-restaurant-216',
				'u-line-icon-pro icon-hotel-restaurant-215',
				'u-line-icon-pro icon-hotel-restaurant-214',
				'u-line-icon-pro icon-hotel-restaurant-213',
				'u-line-icon-pro icon-hotel-restaurant-212',
				'u-line-icon-pro icon-hotel-restaurant-211',
				'u-line-icon-pro icon-hotel-restaurant-210',
				'u-line-icon-pro icon-hotel-restaurant-209',
				'u-line-icon-pro icon-hotel-restaurant-222',
				'u-line-icon-pro icon-hotel-restaurant-223',
				'u-line-icon-pro icon-hotel-restaurant-224',
				'u-line-icon-pro icon-hotel-restaurant-225',
				'u-line-icon-pro icon-hotel-restaurant-226',
				'u-line-icon-pro icon-hotel-restaurant-227',
				'u-line-icon-pro icon-hotel-restaurant-228',
				'u-line-icon-pro icon-hotel-restaurant-229',
				'u-line-icon-pro icon-hotel-restaurant-230',
				'u-line-icon-pro icon-hotel-restaurant-231',
				'u-line-icon-pro icon-hotel-restaurant-232',
				'u-line-icon-pro icon-hotel-restaurant-233',
				'u-line-icon-pro icon-hotel-restaurant-234',
				'u-line-icon-pro icon-hotel-restaurant-247',
				'u-line-icon-pro icon-hotel-restaurant-246',
				'u-line-icon-pro icon-hotel-restaurant-245',
				'u-line-icon-pro icon-hotel-restaurant-244',
				'u-line-icon-pro icon-hotel-restaurant-243',
				'u-line-icon-pro icon-hotel-restaurant-242',
				'u-line-icon-pro icon-hotel-restaurant-241',
				'u-line-icon-pro icon-hotel-restaurant-240',
				'u-line-icon-pro icon-hotel-restaurant-239',
				'u-line-icon-pro icon-hotel-restaurant-238',
				'u-line-icon-pro icon-hotel-restaurant-237',
				'u-line-icon-pro icon-hotel-restaurant-236',
				'u-line-icon-pro icon-hotel-restaurant-235',
				'u-line-icon-pro icon-hotel-restaurant-248',
				'u-line-icon-pro icon-hotel-restaurant-249',
				'u-line-icon-pro icon-hotel-restaurant-250',
			],
		},
		{
			id: 'simple_line_1',
			name: Loc.getMessage('LANDING_ICONS_SECTION_REAL_ESTATE'),
			items: [
				'u-line-icon-pro icon-real-estate-001',
				'u-line-icon-pro icon-real-estate-014',
				'u-line-icon-pro icon-real-estate-027',
				'u-line-icon-pro icon-real-estate-040',
				'u-line-icon-pro icon-real-estate-053',
				'u-line-icon-pro icon-real-estate-066',
				'u-line-icon-pro icon-real-estate-079',
				'u-line-icon-pro icon-real-estate-080',
				'u-line-icon-pro icon-real-estate-081',
				'u-line-icon-pro icon-real-estate-082',
				'u-line-icon-pro icon-real-estate-083',
				'u-line-icon-pro icon-real-estate-084',
				'u-line-icon-pro icon-real-estate-085',
				'u-line-icon-pro icon-real-estate-086',
				'u-line-icon-pro icon-real-estate-087',
				'u-line-icon-pro icon-real-estate-088',
				'u-line-icon-pro icon-real-estate-089',
				'u-line-icon-pro icon-real-estate-090',
				'u-line-icon-pro icon-real-estate-077',
				'u-line-icon-pro icon-real-estate-078',
				'u-line-icon-pro icon-real-estate-065',
				'u-line-icon-pro icon-real-estate-064',
				'u-line-icon-pro icon-real-estate-063',
				'u-line-icon-pro icon-real-estate-076',
				'u-line-icon-pro icon-real-estate-075',
				'u-line-icon-pro icon-real-estate-062',
				'u-line-icon-pro icon-real-estate-061',
				'u-line-icon-pro icon-real-estate-074',
				'u-line-icon-pro icon-real-estate-073',
				'u-line-icon-pro icon-real-estate-059',
				'u-line-icon-pro icon-real-estate-072',
				'u-line-icon-pro icon-real-estate-060',
				'u-line-icon-pro icon-real-estate-058',
				'u-line-icon-pro icon-real-estate-071',
				'u-line-icon-pro icon-real-estate-070',
				'u-line-icon-pro icon-real-estate-057',
				'u-line-icon-pro icon-real-estate-056',
				'u-line-icon-pro icon-real-estate-069',
				'u-line-icon-pro icon-real-estate-068',
				'u-line-icon-pro icon-real-estate-055',
				'u-line-icon-pro icon-real-estate-054',
				'u-line-icon-pro icon-real-estate-067',
				'u-line-icon-pro icon-real-estate-041',
				'u-line-icon-pro icon-real-estate-028',
				'u-line-icon-pro icon-real-estate-015',
				'u-line-icon-pro icon-real-estate-002',
				'u-line-icon-pro icon-real-estate-003',
				'u-line-icon-pro icon-real-estate-016',
				'u-line-icon-pro icon-real-estate-029',
				'u-line-icon-pro icon-real-estate-042',
				'u-line-icon-pro icon-real-estate-043',
				'u-line-icon-pro icon-real-estate-030',
				'u-line-icon-pro icon-real-estate-017',
				'u-line-icon-pro icon-real-estate-004',
				'u-line-icon-pro icon-real-estate-005',
				'u-line-icon-pro icon-real-estate-018',
				'u-line-icon-pro icon-real-estate-031',
				'u-line-icon-pro icon-real-estate-044',
				'u-line-icon-pro icon-real-estate-045',
				'u-line-icon-pro icon-real-estate-032',
				'u-line-icon-pro icon-real-estate-019',
				'u-line-icon-pro icon-real-estate-006',
				'u-line-icon-pro icon-real-estate-008',
				'u-line-icon-pro icon-real-estate-020',
				'u-line-icon-pro icon-real-estate-007',
				'u-line-icon-pro icon-real-estate-021',
				'u-line-icon-pro icon-real-estate-033',
				'u-line-icon-pro icon-real-estate-034',
				'u-line-icon-pro icon-real-estate-047',
				'u-line-icon-pro icon-real-estate-046',
				'u-line-icon-pro icon-real-estate-048',
				'u-line-icon-pro icon-real-estate-035',
				'u-line-icon-pro icon-real-estate-022',
				'u-line-icon-pro icon-real-estate-009',
				'u-line-icon-pro icon-real-estate-011',
				'u-line-icon-pro icon-real-estate-023',
				'u-line-icon-pro icon-real-estate-010',
				'u-line-icon-pro icon-real-estate-024',
				'u-line-icon-pro icon-real-estate-037',
				'u-line-icon-pro icon-real-estate-036',
				'u-line-icon-pro icon-real-estate-049',
				'u-line-icon-pro icon-real-estate-050',
				'u-line-icon-pro icon-real-estate-051',
				'u-line-icon-pro icon-real-estate-038',
				'u-line-icon-pro icon-real-estate-039',
				'u-line-icon-pro icon-real-estate-052',
				'u-line-icon-pro icon-real-estate-026',
				'u-line-icon-pro icon-real-estate-025',
				'u-line-icon-pro icon-real-estate-012',
				'u-line-icon-pro icon-real-estate-013',
			],
		},
		{
			id: 'simple_line_2',
			name: Loc.getMessage('LANDING_ICONS_SECTION_EDUCATION'),
			items: [
				'u-line-icon-pro icon-education-001',
				'u-line-icon-pro icon-education-014',
				'u-line-icon-pro icon-education-027',
				'u-line-icon-pro icon-education-028',
				'u-line-icon-pro icon-education-015',
				'u-line-icon-pro icon-education-002',
				'u-line-icon-pro icon-education-003',
				'u-line-icon-pro icon-education-016',
				'u-line-icon-pro icon-education-029',
				'u-line-icon-pro icon-education-030',
				'u-line-icon-pro icon-education-017',
				'u-line-icon-pro icon-education-004',
				'u-line-icon-pro icon-education-005',
				'u-line-icon-pro icon-education-018',
				'u-line-icon-pro icon-education-031',
				'u-line-icon-pro icon-education-032',
				'u-line-icon-pro icon-education-019',
				'u-line-icon-pro icon-education-006',
				'u-line-icon-pro icon-education-007',
				'u-line-icon-pro icon-education-020',
				'u-line-icon-pro icon-education-033',
				'u-line-icon-pro icon-education-034',
				'u-line-icon-pro icon-education-021',
				'u-line-icon-pro icon-education-008',
				'u-line-icon-pro icon-education-009',
				'u-line-icon-pro icon-education-022',
				'u-line-icon-pro icon-education-035',
				'u-line-icon-pro icon-education-036',
				'u-line-icon-pro icon-education-023',
				'u-line-icon-pro icon-education-010',
				'u-line-icon-pro icon-education-011',
				'u-line-icon-pro icon-education-024',
				'u-line-icon-pro icon-education-037',
				'u-line-icon-pro icon-education-038',
				'u-line-icon-pro icon-education-025',
				'u-line-icon-pro icon-education-012',
				'u-line-icon-pro icon-education-013',
				'u-line-icon-pro icon-education-026',
				'u-line-icon-pro icon-education-039',
				'u-line-icon-pro icon-education-052',
				'u-line-icon-pro icon-education-065',
				'u-line-icon-pro icon-education-078',
				'u-line-icon-pro icon-education-091',
				'u-line-icon-pro icon-education-104',
				'u-line-icon-pro icon-education-117',
				'u-line-icon-pro icon-education-130',
				'u-line-icon-pro icon-education-143',
				'u-line-icon-pro icon-education-142',
				'u-line-icon-pro icon-education-129',
				'u-line-icon-pro icon-education-116',
				'u-line-icon-pro icon-education-103',
				'u-line-icon-pro icon-education-090',
				'u-line-icon-pro icon-education-077',
				'u-line-icon-pro icon-education-064',
				'u-line-icon-pro icon-education-051',
				'u-line-icon-pro icon-education-050',
				'u-line-icon-pro icon-education-063',
				'u-line-icon-pro icon-education-076',
				'u-line-icon-pro icon-education-089',
				'u-line-icon-pro icon-education-088',
				'u-line-icon-pro icon-education-075',
				'u-line-icon-pro icon-education-062',
				'u-line-icon-pro icon-education-049',
				'u-line-icon-pro icon-education-048',
				'u-line-icon-pro icon-education-061',
				'u-line-icon-pro icon-education-074',
				'u-line-icon-pro icon-education-087',
				'u-line-icon-pro icon-education-100',
				'u-line-icon-pro icon-education-101',
				'u-line-icon-pro icon-education-102',
				'u-line-icon-pro icon-education-115',
				'u-line-icon-pro icon-education-114',
				'u-line-icon-pro icon-education-113',
				'u-line-icon-pro icon-education-126',
				'u-line-icon-pro icon-education-127',
				'u-line-icon-pro icon-education-128',
				'u-line-icon-pro icon-education-141',
				'u-line-icon-pro icon-education-140',
				'u-line-icon-pro icon-education-139',
				'u-line-icon-pro icon-education-138',
				'u-line-icon-pro icon-education-125',
				'u-line-icon-pro icon-education-124',
				'u-line-icon-pro icon-education-137',
				'u-line-icon-pro icon-education-136',
				'u-line-icon-pro icon-education-123',
				'u-line-icon-pro icon-education-110',
				'u-line-icon-pro icon-education-111',
				'u-line-icon-pro icon-education-112',
				'u-line-icon-pro icon-education-099',
				'u-line-icon-pro icon-education-098',
				'u-line-icon-pro icon-education-097',
				'u-line-icon-pro icon-education-084',
				'u-line-icon-pro icon-education-085',
				'u-line-icon-pro icon-education-086',
				'u-line-icon-pro icon-education-073',
				'u-line-icon-pro icon-education-072',
				'u-line-icon-pro icon-education-071',
				'u-line-icon-pro icon-education-058',
				'u-line-icon-pro icon-education-059',
				'u-line-icon-pro icon-education-060',
				'u-line-icon-pro icon-education-047',
				'u-line-icon-pro icon-education-046',
				'u-line-icon-pro icon-education-045',
				'u-line-icon-pro icon-education-040',
				'u-line-icon-pro icon-education-041',
				'u-line-icon-pro icon-education-054',
				'u-line-icon-pro icon-education-053',
				'u-line-icon-pro icon-education-066',
				'u-line-icon-pro icon-education-067',
				'u-line-icon-pro icon-education-068',
				'u-line-icon-pro icon-education-055',
				'u-line-icon-pro icon-education-042',
				'u-line-icon-pro icon-education-043',
				'u-line-icon-pro icon-education-056',
				'u-line-icon-pro icon-education-069',
				'u-line-icon-pro icon-education-070',
				'u-line-icon-pro icon-education-057',
				'u-line-icon-pro icon-education-044',
				'u-line-icon-pro icon-education-083',
				'u-line-icon-pro icon-education-082',
				'u-line-icon-pro icon-education-081',
				'u-line-icon-pro icon-education-080',
				'u-line-icon-pro icon-education-079',
				'u-line-icon-pro icon-education-092',
				'u-line-icon-pro icon-education-105',
				'u-line-icon-pro icon-education-118',
				'u-line-icon-pro icon-education-131',
				'u-line-icon-pro icon-education-132',
				'u-line-icon-pro icon-education-119',
				'u-line-icon-pro icon-education-106',
				'u-line-icon-pro icon-education-093',
				'u-line-icon-pro icon-education-094',
				'u-line-icon-pro icon-education-107',
				'u-line-icon-pro icon-education-120',
				'u-line-icon-pro icon-education-133',
				'u-line-icon-pro icon-education-134',
				'u-line-icon-pro icon-education-108',
				'u-line-icon-pro icon-education-095',
				'u-line-icon-pro icon-education-096',
				'u-line-icon-pro icon-education-109',
				'u-line-icon-pro icon-education-122',
				'u-line-icon-pro icon-education-121',
				'u-line-icon-pro icon-education-135',
				'u-line-icon-pro icon-education-144',
				'u-line-icon-pro icon-education-157',
				'u-line-icon-pro icon-education-170',
				'u-line-icon-pro icon-education-183',
				'u-line-icon-pro icon-education-196',
				'u-line-icon-pro icon-education-197',
				'u-line-icon-pro icon-education-184',
				'u-line-icon-pro icon-education-171',
				'u-line-icon-pro icon-education-158',
				'u-line-icon-pro icon-education-145',
				'u-line-icon-pro icon-education-146',
				'u-line-icon-pro icon-education-159',
				'u-line-icon-pro icon-education-172',
				'u-line-icon-pro icon-education-185',
				'u-line-icon-pro icon-education-198',
				'u-line-icon-pro icon-education-199',
				'u-line-icon-pro icon-education-186',
				'u-line-icon-pro icon-education-173',
				'u-line-icon-pro icon-education-160',
				'u-line-icon-pro icon-education-147',
				'u-line-icon-pro icon-education-148',
				'u-line-icon-pro icon-education-161',
				'u-line-icon-pro icon-education-174',
				'u-line-icon-pro icon-education-187',
				'u-line-icon-pro icon-education-200',
				'u-line-icon-pro icon-education-188',
				'u-line-icon-pro icon-education-175',
				'u-line-icon-pro icon-education-162',
				'u-line-icon-pro icon-education-149',
				'u-line-icon-pro icon-education-150',
				'u-line-icon-pro icon-education-163',
				'u-line-icon-pro icon-education-176',
				'u-line-icon-pro icon-education-189',
				'u-line-icon-pro icon-education-190',
				'u-line-icon-pro icon-education-177',
				'u-line-icon-pro icon-education-164',
				'u-line-icon-pro icon-education-151',
				'u-line-icon-pro icon-education-152',
				'u-line-icon-pro icon-education-165',
				'u-line-icon-pro icon-education-178',
				'u-line-icon-pro icon-education-191',
				'u-line-icon-pro icon-education-192',
				'u-line-icon-pro icon-education-179',
				'u-line-icon-pro icon-education-166',
				'u-line-icon-pro icon-education-153',
				'u-line-icon-pro icon-education-154',
				'u-line-icon-pro icon-education-167',
				'u-line-icon-pro icon-education-180',
				'u-line-icon-pro icon-education-193',
				'u-line-icon-pro icon-education-194',
				'u-line-icon-pro icon-education-181',
				'u-line-icon-pro icon-education-168',
				'u-line-icon-pro icon-education-155',
				'u-line-icon-pro icon-education-156',
				'u-line-icon-pro icon-education-169',
				'u-line-icon-pro icon-education-182',
				'u-line-icon-pro icon-education-195',
			],
		}, {
			id: 'simple_line_3',
			name: Loc.getMessage('LANDING_ICONS_SECTION_FINANCE'),
			items: [
				'u-line-icon-pro icon-finance-260',
				'u-line-icon-pro icon-finance-259',
				'u-line-icon-pro icon-finance-246',
				'u-line-icon-pro icon-finance-247',
				'u-line-icon-pro icon-finance-234',
				'u-line-icon-pro icon-finance-233',
				'u-line-icon-pro icon-finance-232',
				'u-line-icon-pro icon-finance-245',
				'u-line-icon-pro icon-finance-258',
				'u-line-icon-pro icon-finance-257',
				'u-line-icon-pro icon-finance-256',
				'u-line-icon-pro icon-finance-243',
				'u-line-icon-pro icon-finance-244',
				'u-line-icon-pro icon-finance-231',
				'u-line-icon-pro icon-finance-230',
				'u-line-icon-pro icon-finance-229',
				'u-line-icon-pro icon-finance-242',
				'u-line-icon-pro icon-finance-255',
				'u-line-icon-pro icon-finance-254',
				'u-line-icon-pro icon-finance-241',
				'u-line-icon-pro icon-finance-228',
				'u-line-icon-pro icon-finance-227',
				'u-line-icon-pro icon-finance-240',
				'u-line-icon-pro icon-finance-253',
				'u-line-icon-pro icon-finance-252',
				'u-line-icon-pro icon-finance-239',
				'u-line-icon-pro icon-finance-226',
				'u-line-icon-pro icon-finance-225',
				'u-line-icon-pro icon-finance-238',
				'u-line-icon-pro icon-finance-251',
				'u-line-icon-pro icon-finance-250',
				'u-line-icon-pro icon-finance-237',
				'u-line-icon-pro icon-finance-224',
				'u-line-icon-pro icon-finance-223',
				'u-line-icon-pro icon-finance-236',
				'u-line-icon-pro icon-finance-249',
				'u-line-icon-pro icon-finance-235',
				'u-line-icon-pro icon-finance-222',
				'u-line-icon-pro icon-finance-248',
				'u-line-icon-pro icon-finance-209',
				'u-line-icon-pro icon-finance-196',
				'u-line-icon-pro icon-finance-183',
				'u-line-icon-pro icon-finance-184',
				'u-line-icon-pro icon-finance-197',
				'u-line-icon-pro icon-finance-210',
				'u-line-icon-pro icon-finance-211',
				'u-line-icon-pro icon-finance-198',
				'u-line-icon-pro icon-finance-185',
				'u-line-icon-pro icon-finance-186',
				'u-line-icon-pro icon-finance-199',
				'u-line-icon-pro icon-finance-212',
				'u-line-icon-pro icon-finance-213',
				'u-line-icon-pro icon-finance-200',
				'u-line-icon-pro icon-finance-187',
				'u-line-icon-pro icon-finance-188',
				'u-line-icon-pro icon-finance-189',
				'u-line-icon-pro icon-finance-201',
				'u-line-icon-pro icon-finance-214',
				'u-line-icon-pro icon-finance-215',
				'u-line-icon-pro icon-finance-202',
				'u-line-icon-pro icon-finance-216',
				'u-line-icon-pro icon-finance-203',
				'u-line-icon-pro icon-finance-204',
				'u-line-icon-pro icon-finance-217',
				'u-line-icon-pro icon-finance-191',
				'u-line-icon-pro icon-finance-190',
				'u-line-icon-pro icon-finance-192',
				'u-line-icon-pro icon-finance-205',
				'u-line-icon-pro icon-finance-218',
				'u-line-icon-pro icon-finance-219',
				'u-line-icon-pro icon-finance-206',
				'u-line-icon-pro icon-finance-193',
				'u-line-icon-pro icon-finance-194',
				'u-line-icon-pro icon-finance-207',
				'u-line-icon-pro icon-finance-220',
				'u-line-icon-pro icon-finance-221',
				'u-line-icon-pro icon-finance-208',
				'u-line-icon-pro icon-finance-195',
				'u-line-icon-pro icon-finance-182',
				'u-line-icon-pro icon-finance-181',
				'u-line-icon-pro icon-finance-180',
				'u-line-icon-pro icon-finance-167',
				'u-line-icon-pro icon-finance-168',
				'u-line-icon-pro icon-finance-169',
				'u-line-icon-pro icon-finance-156',
				'u-line-icon-pro icon-finance-155',
				'u-line-icon-pro icon-finance-154',
				'u-line-icon-pro icon-finance-141',
				'u-line-icon-pro icon-finance-142',
				'u-line-icon-pro icon-finance-143',
				'u-line-icon-pro icon-finance-130',
				'u-line-icon-pro icon-finance-129',
				'u-line-icon-pro icon-finance-128',
				'u-line-icon-pro icon-finance-127',
				'u-line-icon-pro icon-finance-140',
				'u-line-icon-pro icon-finance-139',
				'u-line-icon-pro icon-finance-126',
				'u-line-icon-pro icon-finance-125',
				'u-line-icon-pro icon-finance-138',
				'u-line-icon-pro icon-finance-151',
				'u-line-icon-pro icon-finance-152',
				'u-line-icon-pro icon-finance-153',
				'u-line-icon-pro icon-finance-166',
				'u-line-icon-pro icon-finance-179',
				'u-line-icon-pro icon-finance-178',
				'u-line-icon-pro icon-finance-165',
				'u-line-icon-pro icon-finance-164',
				'u-line-icon-pro icon-finance-177',
				'u-line-icon-pro icon-finance-176',
				'u-line-icon-pro icon-finance-163',
				'u-line-icon-pro icon-finance-150',
				'u-line-icon-pro icon-finance-137',
				'u-line-icon-pro icon-finance-124',
				'u-line-icon-pro icon-finance-123',
				'u-line-icon-pro icon-finance-136',
				'u-line-icon-pro icon-finance-149',
				'u-line-icon-pro icon-finance-162',
				'u-line-icon-pro icon-finance-175',
				'u-line-icon-pro icon-finance-174',
				'u-line-icon-pro icon-finance-161',
				'u-line-icon-pro icon-finance-148',
				'u-line-icon-pro icon-finance-135',
				'u-line-icon-pro icon-finance-122',
				'u-line-icon-pro icon-finance-121',
				'u-line-icon-pro icon-finance-134',
				'u-line-icon-pro icon-finance-147',
				'u-line-icon-pro icon-finance-160',
				'u-line-icon-pro icon-finance-173',
				'u-line-icon-pro icon-finance-172',
				'u-line-icon-pro icon-finance-146',
				'u-line-icon-pro icon-finance-133',
				'u-line-icon-pro icon-finance-120',
				'u-line-icon-pro icon-finance-159',
				'u-line-icon-pro icon-finance-158',
				'u-line-icon-pro icon-finance-171',
				'u-line-icon-pro icon-finance-170',
				'u-line-icon-pro icon-finance-157',
				'u-line-icon-pro icon-finance-144',
				'u-line-icon-pro icon-finance-145',
				'u-line-icon-pro icon-finance-132',
				'u-line-icon-pro icon-finance-131',
				'u-line-icon-pro icon-finance-118',
				'u-line-icon-pro icon-finance-119',
				'u-line-icon-pro icon-finance-106',
				'u-line-icon-pro icon-finance-105',
				'u-line-icon-pro icon-finance-092',
				'u-line-icon-pro icon-finance-093',
				'u-line-icon-pro icon-finance-107',
				'u-line-icon-pro icon-finance-094',
				'u-line-icon-pro icon-finance-095',
				'u-line-icon-pro icon-finance-108',
				'u-line-icon-pro icon-finance-109',
				'u-line-icon-pro icon-finance-096',
				'u-line-icon-pro icon-finance-097',
				'u-line-icon-pro icon-finance-110',
				'u-line-icon-pro icon-finance-111',
				'u-line-icon-pro icon-finance-098',
				'u-line-icon-pro icon-finance-099',
				'u-line-icon-pro icon-finance-112',
				'u-line-icon-pro icon-finance-113',
				'u-line-icon-pro icon-finance-100',
				'u-line-icon-pro icon-finance-101',
				'u-line-icon-pro icon-finance-114',
				'u-line-icon-pro icon-finance-115',
				'u-line-icon-pro icon-finance-102',
				'u-line-icon-pro icon-finance-116',
				'u-line-icon-pro icon-finance-117',
				'u-line-icon-pro icon-finance-104',
				'u-line-icon-pro icon-finance-103',
				'u-line-icon-pro icon-finance-014',
				'u-line-icon-pro icon-finance-027',
				'u-line-icon-pro icon-finance-040',
				'u-line-icon-pro icon-finance-053',
				'u-line-icon-pro icon-finance-066',
				'u-line-icon-pro icon-finance-079',
				'u-line-icon-pro icon-finance-080',
				'u-line-icon-pro icon-finance-067',
				'u-line-icon-pro icon-finance-068',
				'u-line-icon-pro icon-finance-081',
				'u-line-icon-pro icon-finance-070',
				'u-line-icon-pro icon-finance-083',
				'u-line-icon-pro icon-finance-082',
				'u-line-icon-pro icon-finance-069',
				'u-line-icon-pro icon-finance-071',
				'u-line-icon-pro icon-finance-084',
				'u-line-icon-pro icon-finance-085',
				'u-line-icon-pro icon-finance-072',
				'u-line-icon-pro icon-finance-073',
				'u-line-icon-pro icon-finance-086',
				'u-line-icon-pro icon-finance-087',
				'u-line-icon-pro icon-finance-074',
				'u-line-icon-pro icon-finance-088',
				'u-line-icon-pro icon-finance-089',
				'u-line-icon-pro icon-finance-076',
				'u-line-icon-pro icon-finance-077',
				'u-line-icon-pro icon-finance-090',
				'u-line-icon-pro icon-finance-091',
				'u-line-icon-pro icon-finance-078',
				'u-line-icon-pro icon-finance-065',
				'u-line-icon-pro icon-finance-052',
				'u-line-icon-pro icon-finance-039',
				'u-line-icon-pro icon-finance-026',
				'u-line-icon-pro icon-finance-025',
				'u-line-icon-pro icon-finance-038',
				'u-line-icon-pro icon-finance-051',
				'u-line-icon-pro icon-finance-064',
				'u-line-icon-pro icon-finance-063',
				'u-line-icon-pro icon-finance-050',
				'u-line-icon-pro icon-finance-037',
				'u-line-icon-pro icon-finance-024',
				'u-line-icon-pro icon-finance-023',
				'u-line-icon-pro icon-finance-036',
				'u-line-icon-pro icon-finance-049',
				'u-line-icon-pro icon-finance-062',
				'u-line-icon-pro icon-finance-061',
				'u-line-icon-pro icon-finance-048',
				'u-line-icon-pro icon-finance-035',
				'u-line-icon-pro icon-finance-022',
				'u-line-icon-pro icon-finance-021',
				'u-line-icon-pro icon-finance-034',
				'u-line-icon-pro icon-finance-047',
				'u-line-icon-pro icon-finance-060',
				'u-line-icon-pro icon-finance-059',
				'u-line-icon-pro icon-finance-046',
				'u-line-icon-pro icon-finance-033',
				'u-line-icon-pro icon-finance-020',
				'u-line-icon-pro icon-finance-019',
				'u-line-icon-pro icon-finance-032',
				'u-line-icon-pro icon-finance-045',
				'u-line-icon-pro icon-finance-058',
				'u-line-icon-pro icon-finance-057',
				'u-line-icon-pro icon-finance-044',
				'u-line-icon-pro icon-finance-031',
				'u-line-icon-pro icon-finance-018',
				'u-line-icon-pro icon-finance-017',
				'u-line-icon-pro icon-finance-030',
				'u-line-icon-pro icon-finance-043',
				'u-line-icon-pro icon-finance-056',
				'u-line-icon-pro icon-finance-055',
				'u-line-icon-pro icon-finance-042',
				'u-line-icon-pro icon-finance-029',
				'u-line-icon-pro icon-finance-016',
				'u-line-icon-pro icon-finance-015',
				'u-line-icon-pro icon-finance-028',
				'u-line-icon-pro icon-finance-041',
				'u-line-icon-pro icon-finance-054',
				'u-line-icon-pro icon-finance-001',
				'u-line-icon-pro icon-finance-002',
				'u-line-icon-pro icon-finance-003',
				'u-line-icon-pro icon-finance-004',
				'u-line-icon-pro icon-finance-005',
				'u-line-icon-pro icon-finance-006',
				'u-line-icon-pro icon-finance-007',
				'u-line-icon-pro icon-finance-008',
				'u-line-icon-pro icon-finance-009',
				'u-line-icon-pro icon-finance-010',
				'u-line-icon-pro icon-finance-011',
				'u-line-icon-pro icon-finance-012',
				'u-line-icon-pro icon-finance-013',
			],
		},
		{
			id: 'simple_line_4',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TRANSPORTATION'),
			items: [
				'u-line-icon-pro icon-transport-001',
				'u-line-icon-pro icon-transport-014',
				'u-line-icon-pro icon-transport-015',
				'u-line-icon-pro icon-transport-002',
				'u-line-icon-pro icon-transport-003',
				'u-line-icon-pro icon-transport-016',
				'u-line-icon-pro icon-transport-017',
				'u-line-icon-pro icon-transport-004',
				'u-line-icon-pro icon-transport-005',
				'u-line-icon-pro icon-transport-018',
				'u-line-icon-pro icon-transport-019',
				'u-line-icon-pro icon-transport-006',
				'u-line-icon-pro icon-transport-007',
				'u-line-icon-pro icon-transport-020',
				'u-line-icon-pro icon-transport-021',
				'u-line-icon-pro icon-transport-008',
				'u-line-icon-pro icon-transport-009',
				'u-line-icon-pro icon-transport-022',
				'u-line-icon-pro icon-transport-023',
				'u-line-icon-pro icon-transport-010',
				'u-line-icon-pro icon-transport-024',
				'u-line-icon-pro icon-transport-025',
				'u-line-icon-pro icon-transport-012',
				'u-line-icon-pro icon-transport-011',
				'u-line-icon-pro icon-transport-013',
				'u-line-icon-pro icon-transport-026',
				'u-line-icon-pro icon-transport-039',
				'u-line-icon-pro icon-transport-052',
				'u-line-icon-pro icon-transport-051',
				'u-line-icon-pro icon-transport-038',
				'u-line-icon-pro icon-transport-037',
				'u-line-icon-pro icon-transport-050',
				'u-line-icon-pro icon-transport-049',
				'u-line-icon-pro icon-transport-036',
				'u-line-icon-pro icon-transport-035',
				'u-line-icon-pro icon-transport-048',
				'u-line-icon-pro icon-transport-047',
				'u-line-icon-pro icon-transport-034',
				'u-line-icon-pro icon-transport-033',
				'u-line-icon-pro icon-transport-046',
				'u-line-icon-pro icon-transport-045',
				'u-line-icon-pro icon-transport-032',
				'u-line-icon-pro icon-transport-031',
				'u-line-icon-pro icon-transport-044',
				'u-line-icon-pro icon-transport-043',
				'u-line-icon-pro icon-transport-030',
				'u-line-icon-pro icon-transport-029',
				'u-line-icon-pro icon-transport-042',
				'u-line-icon-pro icon-transport-041',
				'u-line-icon-pro icon-transport-028',
				'u-line-icon-pro icon-transport-027',
				'u-line-icon-pro icon-transport-040',
				'u-line-icon-pro icon-transport-053',
				'u-line-icon-pro icon-transport-066',
				'u-line-icon-pro icon-transport-079',
				'u-line-icon-pro icon-transport-092',
				'u-line-icon-pro icon-transport-093',
				'u-line-icon-pro icon-transport-080',
				'u-line-icon-pro icon-transport-067',
				'u-line-icon-pro icon-transport-054',
				'u-line-icon-pro icon-transport-055',
				'u-line-icon-pro icon-transport-068',
				'u-line-icon-pro icon-transport-081',
				'u-line-icon-pro icon-transport-094',
				'u-line-icon-pro icon-transport-095',
				'u-line-icon-pro icon-transport-082',
				'u-line-icon-pro icon-transport-069',
				'u-line-icon-pro icon-transport-056',
				'u-line-icon-pro icon-transport-057',
				'u-line-icon-pro icon-transport-070',
				'u-line-icon-pro icon-transport-083',
				'u-line-icon-pro icon-transport-096',
				'u-line-icon-pro icon-transport-097',
				'u-line-icon-pro icon-transport-084',
				'u-line-icon-pro icon-transport-071',
				'u-line-icon-pro icon-transport-058',
				'u-line-icon-pro icon-transport-059',
				'u-line-icon-pro icon-transport-072',
				'u-line-icon-pro icon-transport-085',
				'u-line-icon-pro icon-transport-098',
				'u-line-icon-pro icon-transport-099',
				'u-line-icon-pro icon-transport-086',
				'u-line-icon-pro icon-transport-073',
				'u-line-icon-pro icon-transport-060',
				'u-line-icon-pro icon-transport-061',
				'u-line-icon-pro icon-transport-074',
				'u-line-icon-pro icon-transport-087',
				'u-line-icon-pro icon-transport-100',
				'u-line-icon-pro icon-transport-088',
				'u-line-icon-pro icon-transport-075',
				'u-line-icon-pro icon-transport-076',
				'u-line-icon-pro icon-transport-089',
				'u-line-icon-pro icon-transport-090',
				'u-line-icon-pro icon-transport-077',
				'u-line-icon-pro icon-transport-078',
				'u-line-icon-pro icon-transport-091',
				'u-line-icon-pro icon-transport-065',
				'u-line-icon-pro icon-transport-064',
				'u-line-icon-pro icon-transport-063',
				'u-line-icon-pro icon-transport-062',
			],
		},
		{
			id: 'simple_line_5',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TRAVEL'),
			items: [
				'u-line-icon-pro icon-travel-001',
				'u-line-icon-pro icon-travel-014',
				'u-line-icon-pro icon-travel-015',
				'u-line-icon-pro icon-travel-002',
				'u-line-icon-pro icon-travel-003',
				'u-line-icon-pro icon-travel-016',
				'u-line-icon-pro icon-travel-017',
				'u-line-icon-pro icon-travel-004',
				'u-line-icon-pro icon-travel-005',
				'u-line-icon-pro icon-travel-018',
				'u-line-icon-pro icon-travel-019',
				'u-line-icon-pro icon-travel-006',
				'u-line-icon-pro icon-travel-007',
				'u-line-icon-pro icon-travel-020',
				'u-line-icon-pro icon-travel-021',
				'u-line-icon-pro icon-travel-008',
				'u-line-icon-pro icon-travel-009',
				'u-line-icon-pro icon-travel-022',
				'u-line-icon-pro icon-travel-023',
				'u-line-icon-pro icon-travel-010',
				'u-line-icon-pro icon-travel-011',
				'u-line-icon-pro icon-travel-024',
				'u-line-icon-pro icon-travel-025',
				'u-line-icon-pro icon-travel-012',
				'u-line-icon-pro icon-travel-013',
				'u-line-icon-pro icon-travel-026',
				'u-line-icon-pro icon-travel-039',
				'u-line-icon-pro icon-travel-052',
				'u-line-icon-pro icon-travel-065',
				'u-line-icon-pro icon-travel-064',
				'u-line-icon-pro icon-travel-051',
				'u-line-icon-pro icon-travel-038',
				'u-line-icon-pro icon-travel-037',
				'u-line-icon-pro icon-travel-050',
				'u-line-icon-pro icon-travel-063',
				'u-line-icon-pro icon-travel-062',
				'u-line-icon-pro icon-travel-049',
				'u-line-icon-pro icon-travel-036',
				'u-line-icon-pro icon-travel-035',
				'u-line-icon-pro icon-travel-048',
				'u-line-icon-pro icon-travel-061',
				'u-line-icon-pro icon-travel-060',
				'u-line-icon-pro icon-travel-047',
				'u-line-icon-pro icon-travel-034',
				'u-line-icon-pro icon-travel-033',
				'u-line-icon-pro icon-travel-046',
				'u-line-icon-pro icon-travel-059',
				'u-line-icon-pro icon-travel-058',
				'u-line-icon-pro icon-travel-045',
				'u-line-icon-pro icon-travel-032',
				'u-line-icon-pro icon-travel-031',
				'u-line-icon-pro icon-travel-044',
				'u-line-icon-pro icon-travel-057',
				'u-line-icon-pro icon-travel-056',
				'u-line-icon-pro icon-travel-043',
				'u-line-icon-pro icon-travel-030',
				'u-line-icon-pro icon-travel-029',
				'u-line-icon-pro icon-travel-042',
				'u-line-icon-pro icon-travel-055',
				'u-line-icon-pro icon-travel-054',
				'u-line-icon-pro icon-travel-041',
				'u-line-icon-pro icon-travel-028',
				'u-line-icon-pro icon-travel-027',
				'u-line-icon-pro icon-travel-040',
				'u-line-icon-pro icon-travel-053',
				'u-line-icon-pro icon-travel-066',
				'u-line-icon-pro icon-travel-079',
				'u-line-icon-pro icon-travel-092',
				'u-line-icon-pro icon-travel-105',
				'u-line-icon-pro icon-travel-106',
				'u-line-icon-pro icon-travel-093',
				'u-line-icon-pro icon-travel-080',
				'u-line-icon-pro icon-travel-067',
				'u-line-icon-pro icon-travel-068',
				'u-line-icon-pro icon-travel-081',
				'u-line-icon-pro icon-travel-094',
				'u-line-icon-pro icon-travel-107',
				'u-line-icon-pro icon-travel-108',
				'u-line-icon-pro icon-travel-095',
				'u-line-icon-pro icon-travel-082',
				'u-line-icon-pro icon-travel-069',
				'u-line-icon-pro icon-travel-070',
				'u-line-icon-pro icon-travel-083',
				'u-line-icon-pro icon-travel-096',
				'u-line-icon-pro icon-travel-109',
				'u-line-icon-pro icon-travel-110',
				'u-line-icon-pro icon-travel-097',
				'u-line-icon-pro icon-travel-084',
				'u-line-icon-pro icon-travel-071',
				'u-line-icon-pro icon-travel-072',
				'u-line-icon-pro icon-travel-085',
				'u-line-icon-pro icon-travel-098',
				'u-line-icon-pro icon-travel-111',
				'u-line-icon-pro icon-travel-112',
				'u-line-icon-pro icon-travel-099',
				'u-line-icon-pro icon-travel-086',
				'u-line-icon-pro icon-travel-073',
				'u-line-icon-pro icon-travel-074',
				'u-line-icon-pro icon-travel-087',
				'u-line-icon-pro icon-travel-100',
				'u-line-icon-pro icon-travel-113',
				'u-line-icon-pro icon-travel-114',
				'u-line-icon-pro icon-travel-101',
				'u-line-icon-pro icon-travel-088',
				'u-line-icon-pro icon-travel-075',
				'u-line-icon-pro icon-travel-076',
				'u-line-icon-pro icon-travel-089',
				'u-line-icon-pro icon-travel-102',
				'u-line-icon-pro icon-travel-115',
				'u-line-icon-pro icon-travel-116',
				'u-line-icon-pro icon-travel-103',
				'u-line-icon-pro icon-travel-090',
				'u-line-icon-pro icon-travel-077',
				'u-line-icon-pro icon-travel-091',
				'u-line-icon-pro icon-travel-104',
				'u-line-icon-pro icon-travel-117',
				'u-line-icon-pro icon-travel-078',
				'u-line-icon-pro icon-travel-130',
				'u-line-icon-pro icon-travel-143',
				'u-line-icon-pro icon-travel-142',
				'u-line-icon-pro icon-travel-129',
				'u-line-icon-pro icon-travel-128',
				'u-line-icon-pro icon-travel-141',
				'u-line-icon-pro icon-travel-140',
				'u-line-icon-pro icon-travel-127',
				'u-line-icon-pro icon-travel-126',
				'u-line-icon-pro icon-travel-139',
				'u-line-icon-pro icon-travel-138',
				'u-line-icon-pro icon-travel-125',
				'u-line-icon-pro icon-travel-124',
				'u-line-icon-pro icon-travel-137',
				'u-line-icon-pro icon-travel-150',
				'u-line-icon-pro icon-travel-149',
				'u-line-icon-pro icon-travel-136',
				'u-line-icon-pro icon-travel-123',
				'u-line-icon-pro icon-travel-122',
				'u-line-icon-pro icon-travel-135',
				'u-line-icon-pro icon-travel-148',
				'u-line-icon-pro icon-travel-147',
				'u-line-icon-pro icon-travel-134',
				'u-line-icon-pro icon-travel-121',
				'u-line-icon-pro icon-travel-120',
				'u-line-icon-pro icon-travel-133',
				'u-line-icon-pro icon-travel-146',
				'u-line-icon-pro icon-travel-145',
				'u-line-icon-pro icon-travel-132',
				'u-line-icon-pro icon-travel-119',
				'u-line-icon-pro icon-travel-118',
				'u-line-icon-pro icon-travel-131',
				'u-line-icon-pro icon-travel-144',
			],
		},
		{
			id: 'simple_line_6',
			name: Loc.getMessage('LANDING_ICONS_SECTION_FOOD'),
			items: [
				'u-line-icon-pro icon-food-001',
				'u-line-icon-pro icon-food-014',
				'u-line-icon-pro icon-food-027',
				'u-line-icon-pro icon-food-040',
				'u-line-icon-pro icon-food-041',
				'u-line-icon-pro icon-food-028',
				'u-line-icon-pro icon-food-015',
				'u-line-icon-pro icon-food-002',
				'u-line-icon-pro icon-food-003',
				'u-line-icon-pro icon-food-016',
				'u-line-icon-pro icon-food-029',
				'u-line-icon-pro icon-food-042',
				'u-line-icon-pro icon-food-043',
				'u-line-icon-pro icon-food-030',
				'u-line-icon-pro icon-food-017',
				'u-line-icon-pro icon-food-004',
				'u-line-icon-pro icon-food-005',
				'u-line-icon-pro icon-food-018',
				'u-line-icon-pro icon-food-031',
				'u-line-icon-pro icon-food-044',
				'u-line-icon-pro icon-food-045',
				'u-line-icon-pro icon-food-032',
				'u-line-icon-pro icon-food-019',
				'u-line-icon-pro icon-food-006',
				'u-line-icon-pro icon-food-007',
				'u-line-icon-pro icon-food-020',
				'u-line-icon-pro icon-food-033',
				'u-line-icon-pro icon-food-046',
				'u-line-icon-pro icon-food-047',
				'u-line-icon-pro icon-food-034',
				'u-line-icon-pro icon-food-021',
				'u-line-icon-pro icon-food-008',
				'u-line-icon-pro icon-food-009',
				'u-line-icon-pro icon-food-022',
				'u-line-icon-pro icon-food-035',
				'u-line-icon-pro icon-food-048',
				'u-line-icon-pro icon-food-049',
				'u-line-icon-pro icon-food-036',
				'u-line-icon-pro icon-food-023',
				'u-line-icon-pro icon-food-010',
				'u-line-icon-pro icon-food-011',
				'u-line-icon-pro icon-food-024',
				'u-line-icon-pro icon-food-037',
				'u-line-icon-pro icon-food-050',
				'u-line-icon-pro icon-food-051',
				'u-line-icon-pro icon-food-038',
				'u-line-icon-pro icon-food-025',
				'u-line-icon-pro icon-food-012',
				'u-line-icon-pro icon-food-013',
				'u-line-icon-pro icon-food-026',
				'u-line-icon-pro icon-food-039',
				'u-line-icon-pro icon-food-052',
				'u-line-icon-pro icon-food-065',
				'u-line-icon-pro icon-food-078',
				'u-line-icon-pro icon-food-091',
				'u-line-icon-pro icon-food-104',
				'u-line-icon-pro icon-food-103',
				'u-line-icon-pro icon-food-090',
				'u-line-icon-pro icon-food-077',
				'u-line-icon-pro icon-food-064',
				'u-line-icon-pro icon-food-063',
				'u-line-icon-pro icon-food-076',
				'u-line-icon-pro icon-food-089',
				'u-line-icon-pro icon-food-102',
				'u-line-icon-pro icon-food-101',
				'u-line-icon-pro icon-food-088',
				'u-line-icon-pro icon-food-075',
				'u-line-icon-pro icon-food-062',
				'u-line-icon-pro icon-food-061',
				'u-line-icon-pro icon-food-074',
				'u-line-icon-pro icon-food-087',
				'u-line-icon-pro icon-food-100',
				'u-line-icon-pro icon-food-099',
				'u-line-icon-pro icon-food-086',
				'u-line-icon-pro icon-food-073',
				'u-line-icon-pro icon-food-060',
				'u-line-icon-pro icon-food-059',
				'u-line-icon-pro icon-food-072',
				'u-line-icon-pro icon-food-085',
				'u-line-icon-pro icon-food-098',
				'u-line-icon-pro icon-food-097',
				'u-line-icon-pro icon-food-084',
				'u-line-icon-pro icon-food-071',
				'u-line-icon-pro icon-food-058',
				'u-line-icon-pro icon-food-057',
				'u-line-icon-pro icon-food-070',
				'u-line-icon-pro icon-food-083',
				'u-line-icon-pro icon-food-096',
				'u-line-icon-pro icon-food-095',
				'u-line-icon-pro icon-food-082',
				'u-line-icon-pro icon-food-069',
				'u-line-icon-pro icon-food-056',
				'u-line-icon-pro icon-food-055',
				'u-line-icon-pro icon-food-068',
				'u-line-icon-pro icon-food-081',
				'u-line-icon-pro icon-food-094',
				'u-line-icon-pro icon-food-093',
				'u-line-icon-pro icon-food-080',
				'u-line-icon-pro icon-food-067',
				'u-line-icon-pro icon-food-054',
				'u-line-icon-pro icon-food-053',
				'u-line-icon-pro icon-food-066',
				'u-line-icon-pro icon-food-079',
				'u-line-icon-pro icon-food-092',
				'u-line-icon-pro icon-food-105',
				'u-line-icon-pro icon-food-118',
				'u-line-icon-pro icon-food-131',
				'u-line-icon-pro icon-food-144',
				'u-line-icon-pro icon-food-157',
				'u-line-icon-pro icon-food-170',
				'u-line-icon-pro icon-food-171',
				'u-line-icon-pro icon-food-158',
				'u-line-icon-pro icon-food-145',
				'u-line-icon-pro icon-food-132',
				'u-line-icon-pro icon-food-119',
				'u-line-icon-pro icon-food-106',
				'u-line-icon-pro icon-food-107',
				'u-line-icon-pro icon-food-120',
				'u-line-icon-pro icon-food-133',
				'u-line-icon-pro icon-food-146',
				'u-line-icon-pro icon-food-159',
				'u-line-icon-pro icon-food-172',
				'u-line-icon-pro icon-food-173',
				'u-line-icon-pro icon-food-160',
				'u-line-icon-pro icon-food-147',
				'u-line-icon-pro icon-food-134',
				'u-line-icon-pro icon-food-121',
				'u-line-icon-pro icon-food-108',
				'u-line-icon-pro icon-food-109',
				'u-line-icon-pro icon-food-122',
				'u-line-icon-pro icon-food-135',
				'u-line-icon-pro icon-food-148',
				'u-line-icon-pro icon-food-161',
				'u-line-icon-pro icon-food-174',
				'u-line-icon-pro icon-food-175',
				'u-line-icon-pro icon-food-162',
				'u-line-icon-pro icon-food-149',
				'u-line-icon-pro icon-food-136',
				'u-line-icon-pro icon-food-123',
				'u-line-icon-pro icon-food-110',
				'u-line-icon-pro icon-food-111',
				'u-line-icon-pro icon-food-124',
				'u-line-icon-pro icon-food-137',
				'u-line-icon-pro icon-food-150',
				'u-line-icon-pro icon-food-163',
				'u-line-icon-pro icon-food-176',
				'u-line-icon-pro icon-food-177',
				'u-line-icon-pro icon-food-164',
				'u-line-icon-pro icon-food-151',
				'u-line-icon-pro icon-food-138',
				'u-line-icon-pro icon-food-125',
				'u-line-icon-pro icon-food-112',
				'u-line-icon-pro icon-food-113',
				'u-line-icon-pro icon-food-126',
				'u-line-icon-pro icon-food-139',
				'u-line-icon-pro icon-food-152',
				'u-line-icon-pro icon-food-165',
				'u-line-icon-pro icon-food-178',
				'u-line-icon-pro icon-food-191',
				'u-line-icon-pro icon-food-192',
				'u-line-icon-pro icon-food-166',
				'u-line-icon-pro icon-food-153',
				'u-line-icon-pro icon-food-140',
				'u-line-icon-pro icon-food-127',
				'u-line-icon-pro icon-food-114',
				'u-line-icon-pro icon-food-115',
				'u-line-icon-pro icon-food-128',
				'u-line-icon-pro icon-food-129',
				'u-line-icon-pro icon-food-116',
				'u-line-icon-pro icon-food-117',
				'u-line-icon-pro icon-food-130',
				'u-line-icon-pro icon-food-143',
				'u-line-icon-pro icon-food-142',
				'u-line-icon-pro icon-food-141',
				'u-line-icon-pro icon-food-154',
				'u-line-icon-pro icon-food-155',
				'u-line-icon-pro icon-food-156',
				'u-line-icon-pro icon-food-169',
				'u-line-icon-pro icon-food-168',
				'u-line-icon-pro icon-food-167',
				'u-line-icon-pro icon-food-179',
				'u-line-icon-pro icon-food-180',
				'u-line-icon-pro icon-food-181',
				'u-line-icon-pro icon-food-182',
				'u-line-icon-pro icon-food-195',
				'u-line-icon-pro icon-food-194',
				'u-line-icon-pro icon-food-193',
				'u-line-icon-pro icon-food-190',
				'u-line-icon-pro icon-food-189',
				'u-line-icon-pro icon-food-188',
				'u-line-icon-pro icon-food-187',
				'u-line-icon-pro icon-food-185',
				'u-line-icon-pro icon-food-184',
				'u-line-icon-pro icon-food-183',
				'u-line-icon-pro icon-food-186',
				'u-line-icon-pro icon-food-208',
				'u-line-icon-pro icon-food-221',
				'u-line-icon-pro icon-food-220',
				'u-line-icon-pro icon-food-207',
				'u-line-icon-pro icon-food-206',
				'u-line-icon-pro icon-food-219',
				'u-line-icon-pro icon-food-205',
				'u-line-icon-pro icon-food-204',
				'u-line-icon-pro icon-food-217',
				'u-line-icon-pro icon-food-216',
				'u-line-icon-pro icon-food-203',
				'u-line-icon-pro icon-food-202',
				'u-line-icon-pro icon-food-215',
				'u-line-icon-pro icon-food-214',
				'u-line-icon-pro icon-food-201',
				'u-line-icon-pro icon-food-200',
				'u-line-icon-pro icon-food-213',
				'u-line-icon-pro icon-food-212',
				'u-line-icon-pro icon-food-199',
				'u-line-icon-pro icon-food-198',
				'u-line-icon-pro icon-food-211',
				'u-line-icon-pro icon-food-210',
				'u-line-icon-pro icon-food-197',
				'u-line-icon-pro icon-food-196',
				'u-line-icon-pro icon-food-209',
				'u-line-icon-pro icon-food-222',
				'u-line-icon-pro icon-food-235',
				'u-line-icon-pro icon-food-248',
				'u-line-icon-pro icon-food-249',
				'u-line-icon-pro icon-food-236',
				'u-line-icon-pro icon-food-223',
				'u-line-icon-pro icon-food-224',
				'u-line-icon-pro icon-food-237',
				'u-line-icon-pro icon-food-250',
				'u-line-icon-pro icon-food-251',
				'u-line-icon-pro icon-food-238',
				'u-line-icon-pro icon-food-225',
				'u-line-icon-pro icon-food-226',
				'u-line-icon-pro icon-food-239',
				'u-line-icon-pro icon-food-252',
				'u-line-icon-pro icon-food-253',
				'u-line-icon-pro icon-food-240',
				'u-line-icon-pro icon-food-227',
				'u-line-icon-pro icon-food-228',
				'u-line-icon-pro icon-food-241',
				'u-line-icon-pro icon-food-254',
				'u-line-icon-pro icon-food-255',
				'u-line-icon-pro icon-food-242',
				'u-line-icon-pro icon-food-229',
				'u-line-icon-pro icon-food-230',
				'u-line-icon-pro icon-food-243',
				'u-line-icon-pro icon-food-256',
				'u-line-icon-pro icon-food-257',
				'u-line-icon-pro icon-food-244',
				'u-line-icon-pro icon-food-231',
				'u-line-icon-pro icon-food-232',
				'u-line-icon-pro icon-food-245',
				'u-line-icon-pro icon-food-258',
				'u-line-icon-pro icon-food-218',
				'u-line-icon-pro icon-food-233',
				'u-line-icon-pro icon-food-246',
				'u-line-icon-pro icon-food-259',
				'u-line-icon-pro icon-food-260',
				'u-line-icon-pro icon-food-247',
				'u-line-icon-pro icon-food-234',
				'u-line-icon-pro icon-food-273',
				'u-line-icon-pro icon-food-286',
				'u-line-icon-pro icon-food-299',
				'u-line-icon-pro icon-food-298',
				'u-line-icon-pro icon-food-285',
				'u-line-icon-pro icon-food-272',
				'u-line-icon-pro icon-food-271',
				'u-line-icon-pro icon-food-284',
				'u-line-icon-pro icon-food-297',
				'u-line-icon-pro icon-food-296',
				'u-line-icon-pro icon-food-283',
				'u-line-icon-pro icon-food-270',
				'u-line-icon-pro icon-food-269',
				'u-line-icon-pro icon-food-282',
				'u-line-icon-pro icon-food-295',
				'u-line-icon-pro icon-food-294',
				'u-line-icon-pro icon-food-281',
				'u-line-icon-pro icon-food-268',
				'u-line-icon-pro icon-food-267',
				'u-line-icon-pro icon-food-280',
				'u-line-icon-pro icon-food-293',
				'u-line-icon-pro icon-food-292',
				'u-line-icon-pro icon-food-279',
				'u-line-icon-pro icon-food-266',
				'u-line-icon-pro icon-food-265',
				'u-line-icon-pro icon-food-278',
				'u-line-icon-pro icon-food-291',
				'u-line-icon-pro icon-food-290',
				'u-line-icon-pro icon-food-277',
				'u-line-icon-pro icon-food-264',
				'u-line-icon-pro icon-food-263',
				'u-line-icon-pro icon-food-276',
				'u-line-icon-pro icon-food-289',
				'u-line-icon-pro icon-food-288',
				'u-line-icon-pro icon-food-275',
				'u-line-icon-pro icon-food-262',
				'u-line-icon-pro icon-food-261',
				'u-line-icon-pro icon-food-274',
				'u-line-icon-pro icon-food-287',
				'u-line-icon-pro icon-food-300',
			],
		},
		{
			id: 'simple_line_7',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MEDICINE'),
			items: [
				'u-line-icon-pro icon-medical-001',
				'u-line-icon-pro icon-medical-002',
				'u-line-icon-pro icon-medical-015',
				'u-line-icon-pro icon-medical-014',
				'u-line-icon-pro icon-medical-027',
				'u-line-icon-pro icon-medical-028',
				'u-line-icon-pro icon-medical-029',
				'u-line-icon-pro icon-medical-016',
				'u-line-icon-pro icon-medical-003',
				'u-line-icon-pro icon-medical-004',
				'u-line-icon-pro icon-medical-017',
				'u-line-icon-pro icon-medical-030',
				'u-line-icon-pro icon-medical-031',
				'u-line-icon-pro icon-medical-018',
				'u-line-icon-pro icon-medical-005',
				'u-line-icon-pro icon-medical-006',
				'u-line-icon-pro icon-medical-019',
				'u-line-icon-pro icon-medical-032',
				'u-line-icon-pro icon-medical-033',
				'u-line-icon-pro icon-medical-020',
				'u-line-icon-pro icon-medical-007',
				'u-line-icon-pro icon-medical-008',
				'u-line-icon-pro icon-medical-021',
				'u-line-icon-pro icon-medical-034',
				'u-line-icon-pro icon-medical-035',
				'u-line-icon-pro icon-medical-022',
				'u-line-icon-pro icon-medical-009',
				'u-line-icon-pro icon-medical-010',
				'u-line-icon-pro icon-medical-023',
				'u-line-icon-pro icon-medical-036',
				'u-line-icon-pro icon-medical-037',
				'u-line-icon-pro icon-medical-024',
				'u-line-icon-pro icon-medical-011',
				'u-line-icon-pro icon-medical-012',
				'u-line-icon-pro icon-medical-025',
				'u-line-icon-pro icon-medical-038',
				'u-line-icon-pro icon-medical-039',
				'u-line-icon-pro icon-medical-026',
				'u-line-icon-pro icon-medical-013',
				'u-line-icon-pro icon-medical-040',
				'u-line-icon-pro icon-medical-053',
				'u-line-icon-pro icon-medical-066',
				'u-line-icon-pro icon-medical-079',
				'u-line-icon-pro icon-medical-092',
				'u-line-icon-pro icon-medical-093',
				'u-line-icon-pro icon-medical-080',
				'u-line-icon-pro icon-medical-067',
				'u-line-icon-pro icon-medical-054',
				'u-line-icon-pro icon-medical-041',
				'u-line-icon-pro icon-medical-042',
				'u-line-icon-pro icon-medical-055',
				'u-line-icon-pro icon-medical-068',
				'u-line-icon-pro icon-medical-081',
				'u-line-icon-pro icon-medical-094',
				'u-line-icon-pro icon-medical-096',
				'u-line-icon-pro icon-medical-082',
				'u-line-icon-pro icon-medical-095',
				'u-line-icon-pro icon-medical-069',
				'u-line-icon-pro icon-medical-056',
				'u-line-icon-pro icon-medical-043',
				'u-line-icon-pro icon-medical-044',
				'u-line-icon-pro icon-medical-057',
				'u-line-icon-pro icon-medical-070',
				'u-line-icon-pro icon-medical-083',
				'u-line-icon-pro icon-medical-084',
				'u-line-icon-pro icon-medical-071',
				'u-line-icon-pro icon-medical-058',
				'u-line-icon-pro icon-medical-045',
				'u-line-icon-pro icon-medical-046',
				'u-line-icon-pro icon-medical-059',
				'u-line-icon-pro icon-medical-098',
				'u-line-icon-pro icon-medical-097',
				'u-line-icon-pro icon-medical-085',
				'u-line-icon-pro icon-medical-072',
				'u-line-icon-pro icon-medical-073',
				'u-line-icon-pro icon-medical-086',
				'u-line-icon-pro icon-medical-099',
				'u-line-icon-pro icon-medical-100',
				'u-line-icon-pro icon-medical-087',
				'u-line-icon-pro icon-medical-074',
				'u-line-icon-pro icon-medical-060',
				'u-line-icon-pro icon-medical-061',
				'u-line-icon-pro icon-medical-047',
				'u-line-icon-pro icon-medical-048',
				'u-line-icon-pro icon-medical-049',
				'u-line-icon-pro icon-medical-062',
				'u-line-icon-pro icon-medical-075',
				'u-line-icon-pro icon-medical-088',
				'u-line-icon-pro icon-medical-089',
				'u-line-icon-pro icon-medical-076',
				'u-line-icon-pro icon-medical-063',
				'u-line-icon-pro icon-medical-050',
				'u-line-icon-pro icon-medical-051',
				'u-line-icon-pro icon-medical-064',
				'u-line-icon-pro icon-medical-077',
				'u-line-icon-pro icon-medical-090',
				'u-line-icon-pro icon-medical-091',
				'u-line-icon-pro icon-medical-078',
				'u-line-icon-pro icon-medical-065',
				'u-line-icon-pro icon-medical-052',
			],
		},
		{
			id: 'simple_line_8',
			name: Loc.getMessage('LANDING_ICONS_SECTION_CLOTHES'),
			items: [
				'u-line-icon-pro icon-clothes-014',
				'u-line-icon-pro icon-clothes-027',
				'u-line-icon-pro icon-clothes-040',
				'u-line-icon-pro icon-clothes-053',
				'u-line-icon-pro icon-clothes-066',
				'u-line-icon-pro icon-clothes-079',
				'u-line-icon-pro icon-clothes-092',
				'u-line-icon-pro icon-clothes-093',
				'u-line-icon-pro icon-clothes-080',
				'u-line-icon-pro icon-clothes-067',
				'u-line-icon-pro icon-clothes-054',
				'u-line-icon-pro icon-clothes-041',
				'u-line-icon-pro icon-clothes-028',
				'u-line-icon-pro icon-clothes-015',
				'u-line-icon-pro icon-clothes-016',
				'u-line-icon-pro icon-clothes-029',
				'u-line-icon-pro icon-clothes-042',
				'u-line-icon-pro icon-clothes-055',
				'u-line-icon-pro icon-clothes-068',
				'u-line-icon-pro icon-clothes-081',
				'u-line-icon-pro icon-clothes-094',
				'u-line-icon-pro icon-clothes-095',
				'u-line-icon-pro icon-clothes-082',
				'u-line-icon-pro icon-clothes-083',
				'u-line-icon-pro icon-clothes-096',
				'u-line-icon-pro icon-clothes-097',
				'u-line-icon-pro icon-clothes-084',
				'u-line-icon-pro icon-clothes-085',
				'u-line-icon-pro icon-clothes-098',
				'u-line-icon-pro icon-clothes-099',
				'u-line-icon-pro icon-clothes-086',
				'u-line-icon-pro icon-clothes-087',
				'u-line-icon-pro icon-clothes-100',
				'u-line-icon-pro icon-clothes-088',
				'u-line-icon-pro icon-clothes-089',
				'u-line-icon-pro icon-clothes-090',
				'u-line-icon-pro icon-clothes-091',
				'u-line-icon-pro icon-clothes-078',
				'u-line-icon-pro icon-clothes-077',
				'u-line-icon-pro icon-clothes-076',
				'u-line-icon-pro icon-clothes-075',
				'u-line-icon-pro icon-clothes-074',
				'u-line-icon-pro icon-clothes-073',
				'u-line-icon-pro icon-clothes-072',
				'u-line-icon-pro icon-clothes-071',
				'u-line-icon-pro icon-clothes-070',
				'u-line-icon-pro icon-clothes-069',
				'u-line-icon-pro icon-clothes-056',
				'u-line-icon-pro icon-clothes-043',
				'u-line-icon-pro icon-clothes-030',
				'u-line-icon-pro icon-clothes-017',
				'u-line-icon-pro icon-clothes-018',
				'u-line-icon-pro icon-clothes-031',
				'u-line-icon-pro icon-clothes-044',
				'u-line-icon-pro icon-clothes-057',
				'u-line-icon-pro icon-clothes-058',
				'u-line-icon-pro icon-clothes-045',
				'u-line-icon-pro icon-clothes-032',
				'u-line-icon-pro icon-clothes-019',
				'u-line-icon-pro icon-clothes-020',
				'u-line-icon-pro icon-clothes-033',
				'u-line-icon-pro icon-clothes-046',
				'u-line-icon-pro icon-clothes-059',
				'u-line-icon-pro icon-clothes-060',
				'u-line-icon-pro icon-clothes-047',
				'u-line-icon-pro icon-clothes-034',
				'u-line-icon-pro icon-clothes-021',
				'u-line-icon-pro icon-clothes-022',
				'u-line-icon-pro icon-clothes-035',
				'u-line-icon-pro icon-clothes-048',
				'u-line-icon-pro icon-clothes-061',
				'u-line-icon-pro icon-clothes-062',
				'u-line-icon-pro icon-clothes-049',
				'u-line-icon-pro icon-clothes-036',
				'u-line-icon-pro icon-clothes-023',
				'u-line-icon-pro icon-clothes-024',
				'u-line-icon-pro icon-clothes-037',
				'u-line-icon-pro icon-clothes-050',
				'u-line-icon-pro icon-clothes-063',
				'u-line-icon-pro icon-clothes-064',
				'u-line-icon-pro icon-clothes-051',
				'u-line-icon-pro icon-clothes-038',
				'u-line-icon-pro icon-clothes-025',
				'u-line-icon-pro icon-clothes-026',
				'u-line-icon-pro icon-clothes-039',
				'u-line-icon-pro icon-clothes-052',
				'u-line-icon-pro icon-clothes-065',
				'u-line-icon-pro icon-clothes-001',
				'u-line-icon-pro icon-clothes-002',
				'u-line-icon-pro icon-clothes-003',
				'u-line-icon-pro icon-clothes-004',
				'u-line-icon-pro icon-clothes-005',
				'u-line-icon-pro icon-clothes-006',
				'u-line-icon-pro icon-clothes-007',
				'u-line-icon-pro icon-clothes-008',
				'u-line-icon-pro icon-clothes-009',
				'u-line-icon-pro icon-clothes-010',
				'u-line-icon-pro icon-clothes-011',
				'u-line-icon-pro icon-clothes-012',
				'u-line-icon-pro icon-clothes-013',
			],
		},
	],
};